import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import AddContestPage from "../Modals/Contest/AddContest";
import EditContestPage from "../Modals/Contest/EditContest";
import { FaEye, FaPen } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";
const ContestPage = () => {
  const [contests, setEvents] = useState([]);
  const [showAddEventPopup, setShowAddEventPopup] = useState(false);
  const [showEditEventPopup, setShowEditEventPopup] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [selectedVideoLink, setSelectedVideoLink] = useState(null);
  const navigate = useNavigate();
  const transformToEmbedUrl = (url) => {
    // YouTube Embed
    if (url.includes("youtube.com/shorts/")) {
      const videoId = url.split("/shorts/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    if (url.includes("youtube.com/watch?v=")) {
      const videoId = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Vimeo Embed
    if (url.includes("vimeo.com/")) {
      const videoId = url.split("vimeo.com/")[1];
      return `https://player.vimeo.com/video/${videoId}`;
    }

    // Dailymotion Embed
    if (url.includes("dailymotion.com/video/")) {
      const videoId = url.split("dailymotion.com/video/")[1].split("_")[0];
      return `https://www.dailymotion.com/embed/video/${videoId}`;
    }

    // Instagram Embed (Posts only, not reels or videos)
    if (url.includes("instagram.com/p/")) {
      const shortcode = url.split("instagram.com/p/")[1].split("/")[0];
      return `https://www.instagram.com/embed/${shortcode}`;
    }

    // Instagram Video or Reel: Open in a new tab
    if (
      url.includes("instagram.com/reel/") ||
      url.includes("instagram.com/tv/")
    ) {
      window.open(url, "_blank");
      return null; // Return null to indicate no embed URL
    }

    // Facebook Video: Open in a new tab
    if (
      url.includes("facebook.com/watch/") ||
      url.includes("facebook.com/video/")
    ) {
      window.open(url, "_blank");
      return null; // Return null to indicate no embed URL
    }

    // Return original URL if no match
    return url;
  };

  const handleViewDetailsClick = (contestId) => {
    // Navigate to the detail page with the contest ID
    navigate(`/trainersContestVideo/${contestId}`);
  };

  const handleVideoClick = (link) => {
    const embedLink = transformToEmbedUrl(link);
    setSelectedVideoLink(embedLink); // Set the transformed embed link
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleAddEventClick = () => {
    setShowAddEventPopup(true);
  };

  const handleEditEventClick = (contest) => {
    setCurrentEvent(contest);
    setShowEditEventPopup(true);
  };

  const handleDeleteEventClick = async (contestId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this contest!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`/contests/delete/${contestId}`);
        Swal.fire("Deleted!", "The contest has been deleted.", "success");
        fetchEvents();
      } catch (err) {
        Swal.fire("Error!", "Failed to delete the contest.", "error");
      }
    } else {
      Swal.fire("Cancelled", "The contest was not deleted.", "info");
    }
  };

  const fetchEvents = async () => {
    try {
      const response = await axios.get("/contests/get_all");
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };

  function formatDate(inputDate) {
    const date = new Date(inputDate);

    const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
    const day = date.getDate().toString().padStart(2, "0");
    const monthName = date.toLocaleDateString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${dayName}, ${day} ${monthName} ${year}`;
  }

 

  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <div className="mb-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Contest</h1>
            <button
              onClick={handleAddEventClick}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              Add Contest
            </button>
          </div>
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border px-4 py-2">Title</th>
                <th className="border px-4 py-2">Description</th>
                <th className="border px-4 py-2">Last Date To Apply</th>
                <th className="border px-4 py-2">Status</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {contests.map((contest) => (
                <tr key={contest.id}>
                  <td className="border px-4 py-2">{contest.contest_title}</td>
                  <td className="border px-4 py-2">
                    {contest.contest_description}
                  </td>
                  <td className="border px-4 py-2">
                    {formatDate(contest.contest_last_date_to_apply)}
                  </td>
                  {/* <td className="border px-4 py-2">
                      {contest.video_link ? (
                        <a
                          href="#"
                          onClick={() => handleVideoClick(contest.video_link)}
                          className="text-blue-500 underline hover:text-blue-700"
                        >
                          View Link
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td> */}
                  <td className="border px-4 py-2">{contest.status}</td>
                  <td className="border px-4 py-2 text-center flex">
                    <FaEye
                      className="mt-5 text-xl cursor-pointer text-blue-500 hover:text-blue-700"
                      onClick={() => handleViewDetailsClick(contest.contest_id)}
                    />

                    <FaPen
                      className="text-amber-400 mt-5 ml-2 text-xl cursor-pointer"
                      onClick={() => handleEditEventClick(contest)}
                    />

                    <MdDeleteForever
                      className="ml-2 mt-5 text-red-500 text-xl cursor-pointer"
                      onClick={() => handleDeleteEventClick(contest.contest_id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Modal or Section to Display the Video */}
          {selectedVideoLink && (
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
              <div className="bg-white p-5 rounded-lg shadow-lg">
                <iframe
                  width="560"
                  height="315"
                  src={selectedVideoLink}
                  title="Video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <button
                  onClick={() => setSelectedVideoLink(null)}
                  className="mt-2 px-4 py-2 bg-gray-600 text-white rounded-lg"
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {showAddEventPopup && (
            <AddContestPage
              onClose={() => setShowAddEventPopup(false)}
              onSubmit={fetchEvents}
            />
          )}

          {showEditEventPopup && currentEvent && (
            <EditContestPage
              contestId={currentEvent.contest_id} // Pass contestId here
              onClose={() => setShowEditEventPopup(false)}
              onSubmit={fetchEvents}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ContestPage;
